var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebHeaderView',{attrs:{"title":_vm.$t('menu.mine')}}),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"mine-box"},[_c('MineHeadView',{attrs:{"usr":_vm.usr,"vip":_vm.vip}}),_c('MineBalanceView',{attrs:{"usr":_vm.usr},on:{"refresh":function($event){return _vm.dorefresh()}}}),_c('MineGridView'),_c('MineMenuView')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }